// Lightweight browser detection, replacing the unmaintained `is_js` package
// (GHSA-pvrw-g6fx-mcx2 — ReDoS, no upstream fix). These mirror is_js 0.9.0's
// `is.firefox()` and `is.edge()` semantics exactly (case-insensitive match on the
// user-agent; `edge` matches legacy EdgeHTML "edge/NN", not Chromium "edg/NN").
const userAgent = (): string =>
  (typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent : '').toLowerCase();

export const isFirefox = (): boolean => /(?:firefox|fxios)\/(\d+)/.test(userAgent());

export const isEdge = (): boolean => /edge\/(\d+)/.test(userAgent());
